import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './Cart.css';

const API_URL = process.env.REACT_APP_API_URL || 'https://moyobed.pro';

function Cart({ user, darkMode, toggleTheme }) {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('current');
  const navigate = useNavigate();

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/orders/my`, {
        params: { employee_id: user.id }
      });
      setOrders(response.data);
    } catch (err) {
      console.error('Ошибка загрузки заказов:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (orderId) => {
    if (!window.confirm('Удалить этот заказ?')) return;
    try {
      await axios.delete(`${API_URL}/api/orders/${orderId}`);
      fetchOrders();
    } catch (err) {
      alert('Ошибка удаления: ' + (err.response?.data?.detail || err.message));
    }
  };

  const goToMenu = () => navigate('/menu');

  if (loading) {
    return (
      <div className="page cart-page">
        <div className="loading-screen">
          <div className="loading-spinner"></div>
          <p>Загружаем заказы...</p>
        </div>
      </div>
    );
  }

  // Разделяем на текущие (будущие) и историю (прошедшие)
  const today = new Date().toISOString().split('T')[0];
  const currentOrders = orders.filter(o => o.order_date >= today);
  const historyOrders = orders.filter(o => o.order_date < today);

  // Группируем по датам
  const groupByDate = (ordersList) => {
    const grouped = {};
    ordersList.forEach(order => {
      if (!grouped[order.order_date]) {
        grouped[order.order_date] = [];
      }
      grouped[order.order_date].push(order);
    });
    return Object.entries(grouped).sort((a, b) => a[0].localeCompare(b[0]));
  };

  const currentGrouped = groupByDate(currentOrders);
  const historyGrouped = groupByDate(historyOrders);

  return (
    <div className="page cart-page">
      <header className="menu-header">
        <div className="header-left">
          <h1 className="page-title">🛒 Мои заказы</h1>
          <p className="user-name">{user.last_name || user.full_name}</p>
        </div>
        <div className="header-right">
          <button className="btn btn-sm btn-outline" onClick={toggleTheme}>
            {darkMode ? '☀️' : '🌙'}
          </button>
          <button className="btn btn-sm" onClick={goToMenu}>🍽️ К меню</button>
        </div>
      </header>

      <div className="tabs" style={{ marginBottom: 20 }}>
        <button 
          className={`tab-btn ${activeTab === 'current' ? 'active' : ''}`}
          onClick={() => setActiveTab('current')}
        >
          📋 Текущие ({currentOrders.length})
        </button>
        <button 
          className={`tab-btn ${activeTab === 'history' ? 'active' : ''}`}
          onClick={() => setActiveTab('history')}
        >
          📜 История ({historyOrders.length})
        </button>
      </div>

      {activeTab === 'current' && (
        <div>
          {currentGrouped.length === 0 ? (
            <div className="empty-state card">
              <p>📭 Нет текущих заказов</p>
              <button className="btn" onClick={goToMenu} style={{ marginTop: 12 }}>🍽️ Сделать заказ</button>
            </div>
          ) : (
            currentGrouped.map(([date, dateOrders]) => (
              <div key={date} className="card" style={{ marginBottom: 16 }}>
                <h3 style={{ marginBottom: 12 }}>
                  📅 {new Date(date).toLocaleDateString('ru-RU', { day: 'numeric', month: 'long', weekday: 'long' })}
                </h3>
                {dateOrders.map(order => (
                  <div key={order.id} className="cart-item" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0', borderBottom: '1px solid var(--border)' }}>
                    <div>
                      <div style={{ fontWeight: 500 }}>{order.dish_name}</div>
                      <div style={{ fontSize: 13, color: 'var(--text-light)' }}>{order.day_of_week}</div>
                    </div>
                    <button className="btn btn-sm btn-danger" onClick={() => handleDelete(order.id)}>🗑️</button>
                  </div>
                ))}
              </div>
            ))
          )}
        </div>
      )}

      {activeTab === 'history' && (
        <div>
          {historyGrouped.length === 0 ? (
            <div className="empty-state card">
              <p>📜 История пуста</p>
            </div>
          ) : (
            historyGrouped.map(([date, dateOrders]) => (
              <div key={date} className="card" style={{ marginBottom: 16, opacity: 0.8 }}>
                <h3 style={{ marginBottom: 12 }}>
                  📅 {new Date(date).toLocaleDateString('ru-RU', { day: 'numeric', month: 'long', weekday: 'long' })}
                </h3>
                {dateOrders.map(order => (
                  <div key={order.id} style={{ padding: '6px 0', borderBottom: '1px solid var(--border)' }}>
                    <span>{order.dish_name}</span>
                    {order.is_issued && <span style={{ marginLeft: 8, color: '#10b981', fontSize: 12 }}>✅ Выдан</span>}
                  </div>
                ))}
              </div>
            ))
          )}
        </div>
      )}

      <nav className="bottom-nav">
        <button className="btn" onClick={goToMenu}>🍽️ К меню</button>
      </nav>
    </div>
  );
}

export default Cart;
